import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex align-items-center" }, null, -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "table table-tenant-sm table-hover" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["onClick"]

import { ref, onMounted } from "vue";
import {
  EventShopRewardStatusOptions,
  EventShopRewardRebateStatusTypes,
} from "@/core/types/shop/ShopPointsTypes";
import EventsServices from "../services/EventsServices";
import RewardDetail from "../components/shop/RewardDetail.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ShopRewards',
  setup(__props) {

const isLoading = ref(false);
const data = ref(<any>[]);
const rewardDetailRef = ref<any>(null);
const criteria = ref<any>({
  page: 1,
  size: 25,
  status: EventShopRewardRebateStatusTypes.Pending,
});
const accountSelected = ref(0);
const tab = ref<any>();
const isTabActive = (_tab: any) => {
  return tab.value === _tab;
};

const changeTab = (_value: any) => {
  tab.value = _value;
  criteria.value.status = tab.value;
  if (tab.value === 6) {
    criteria.value.status = null;
  }
  fetchData(1);
};
const showDetail = (item: any) => {
  rewardDetailRef.value?.show(item);
};
const fetchData = async (page: number) => {
  isLoading.value = true;
  criteria.value.page = page;
  try {
    const res = await EventsServices.queryShoppRewards(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.error(error);
  }
  isLoading.value = false;
};

const getStatusLabel = (value: number) => {
  const option = EventShopRewardStatusOptions.value.find(
    (option) => option.value === value
  );
  return option ? option.label : "";
};

function getStatusTag(status: EventShopRewardRebateStatusTypes) {
  switch (status) {
    case EventShopRewardRebateStatusTypes.Pending:
      return "warning";
    case EventShopRewardRebateStatusTypes.Succeed:
      return "success";
    case EventShopRewardRebateStatusTypes.Failed:
      return "danger";
    case EventShopRewardRebateStatusTypes.Processing:
      return "info";
  }
}
const selectedAccount = (id: number) => {
  accountSelected.value = id;
};
onMounted(() => {
  tab.value = EventShopRewardRebateStatusTypes.Pending;
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_ShopPoints = _resolveComponent("ShopPoints")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EventShopRewardStatusOptions), (tab) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "nav-item",
          key: tab.value
        }, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-2", [
          { active: isTabActive(tab.value) },
          { 'disabled opacity-50 pe-none': isLoading.value },
        ]]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: ($event: any) => (changeTab(tab.value))
          }, _toDisplayString(tab.label), 11, _hoisted_2)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.user")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.rewardName")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.totalPoints")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.operator")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: _normalizeClass({
              'tr-select': item.id === accountSelected.value,
            }),
                      onClick: ($event: any) => (selectedAccount(item.id))
                    }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_UserInfo, {
                          email: item.eventPartyEmail,
                          name: item.eventPartyNativeName,
                          partyId: item.partyId,
                          class: "me-2"
                        }, null, 8, ["email", "name", "partyId"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_tag, {
                          type: getStatusTag(item.status)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getStatusLabel(item.status)), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.eventShopItemName), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_ShopPoints, {
                          points: item.totalPoint
                        }, null, 8, ["points"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.operatorName), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "GMToneLiner",
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          onClick: ($event: any) => (showDetail(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.detail")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ], 10, _hoisted_10))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(RewardDetail, {
      ref_key: "rewardDetailRef",
      ref: rewardDetailRef
    }, null, 512)
  ], 64))
}
}

})